"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MODE_EDIT = exports.MODE_ADD = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faPlay = require("@fortawesome/pro-regular-svg-icons/faPlay");

var _peractoUi = require("@peracto/peracto-ui");

var _peractoConfig = require("@peracto/peracto-config");

var _util = require("../util");

var _excluded = ["values", "mode"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MODE_EDIT = 'edit';
exports.MODE_EDIT = MODE_EDIT;
var MODE_ADD = 'add';
exports.MODE_ADD = MODE_ADD;
var statusOptions = [{
  label: 'Active',
  value: 'true'
}, {
  label: 'Inactive',
  value: 'false'
}];
var defaultScheduleValue = {
  label: 'Every',
  value: '*'
};

var generateScheduleOptions = function generateScheduleOptions(_ref) {
  var _ref$max = _ref.max,
      max = _ref$max === void 0 ? 1 : _ref$max,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$selectInterval = _ref.selectInterval,
      selectInterval = _ref$selectInterval === void 0 ? false : _ref$selectInterval,
      multipleOf = _ref.multipleOf,
      labels = _ref.labels;
  var values = [defaultScheduleValue];

  for (var i = min; i <= max; i++) {
    if (!multipleOf || i % multipleOf === 0) {
      if (selectInterval && i > 0) {
        values.push({
          label: "at ".concat(i),
          value: "".concat(i)
        });
        values.push({
          label: "every ".concat(i),
          value: "*/".concat(i)
        });
      } else {
        values.push({
          label: Array.isArray(labels) ? labels[i - min] : i,
          value: "".concat(i)
        });
      }
    }
  }

  return values;
};

var TasksForm = function TasksForm(_ref2) {
  var _values$schedule, _values$schedule2, _values$schedule3;

  var values = _ref2.values,
      mode = _ref2.mode,
      props = _objectWithoutProperties(_ref2, _excluded);

  var config = (0, _peractoConfig.useConfig)();
  var API_URL = config.get('api');

  var _config$get = config.get('features', {}),
      tasks = _config$get.tasks;

  var hideScheduleTimes = tasks === null || tasks === void 0 ? void 0 : tasks.hideScheduleTimes;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoUi.FormActions, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "px-0 btn btn-link",
    onClick: function onClick() {
      return (0, _util.onRunTask)(API_URL, values.code);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlay.faPlay,
    className: "mr-2"
  }), "Run Task Manually")), /*#__PURE__*/_react["default"].createElement(_peractoUi.Form, _extends({
    autoComplete: "off",
    values: _objectSpread(_objectSpread({}, values), {}, {
      active: values.active || 'false',
      schedule: _objectSpread(_objectSpread({}, values.schedule), {}, {
        days: ((_values$schedule = values.schedule) === null || _values$schedule === void 0 ? void 0 : _values$schedule.days) || (mode === MODE_ADD ? '1' : null),
        hours: ((_values$schedule2 = values.schedule) === null || _values$schedule2 === void 0 ? void 0 : _values$schedule2.hours) || (mode === MODE_ADD ? '2' : null),
        minutes: ((_values$schedule3 = values.schedule) === null || _values$schedule3 === void 0 ? void 0 : _values$schedule3.minutes) || (mode === MODE_ADD ? '30' : null)
      })
    })
  }, props), /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "core",
    id: "core",
    name: "Core"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "name",
    label: "Name",
    readOnly: true,
    disabled: true
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Textarea, {
    name: "description",
    label: "Description",
    readOnly: true,
    disabled: true
  })), /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "schedule",
    id: "schedule",
    name: "Schedule"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "active",
    label: "Schedule Status",
    placeholder: "Please select...",
    help: "When Active the task will run according to the configuration set. Tasks should only be run as frequently as is strictly necessary.",
    options: statusOptions
  })), !hideScheduleTimes && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "schedule.months",
    label: "Month",
    placeholder: "Please select...",
    options: generateScheduleOptions({
      max: 12,
      min: 1,
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }),
    defaultValue: {
      label: 'Select time...',
      value: null
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "schedule.days",
    label: "Day",
    placeholder: "Please select...",
    options: generateScheduleOptions({
      max: 31,
      min: 1
    }),
    defaultValue: {
      label: 'Select time...',
      value: null
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "schedule.hours",
    label: "Hour",
    placeholder: "Please select...",
    options: generateScheduleOptions({
      max: 23,
      selectInterval: true
    }),
    defaultValue: {
      label: 'Select time...',
      value: null
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "schedule.minutes",
    label: "Minute",
    placeholder: "Please select...",
    options: generateScheduleOptions({
      max: 59,
      selectInterval: true,
      multipleOf: 5
    }),
    defaultValue: {
      label: 'Select time...',
      value: null
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "schedule.weekdays",
    label: "Weekday",
    placeholder: "Please select...",
    options: generateScheduleOptions({
      max: 6,
      labels: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    }),
    defaultValue: {
      label: 'Select time...',
      value: null
    }
  })))))));
};

TasksForm.displayName = 'TasksForm';
TasksForm.propTypes = {
  values: _propTypes["default"].object,
  schema: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired
};
var _default = TasksForm;
exports["default"] = _default;